goog.provide("shadow.js.shim.module$src$svg$path$path_svg$default");
shadow.js.shim.module$src$svg$path$path_svg$default = shadow.js.shim.module$src$svg$path$path_svg.default;
